<template>
  <div class="row campaign-item" v-if="item" @click.stop="select">
    <!-- <div class="mr-1 column-center">
      <p class="typo-paragraph12 typo-regular text-light-high">{{ `#${item.id}` }}</p>
    </div> -->
    <div class="col-5 col-md-6 column-center pl-half mr-auto info">
      <div class="d-flex mb-1">
        <p class="typo-heading16 typo-medium ellipsis text-light-high title">{{ item.name }}</p>
      </div>
      <p class="typo-paragraph12 typo-regular ellipsis text-light-low">{{ $t("generals.lastModified")}} {{lastModified}}</p>
    </div>
    <div class="col-3 col-md-2 column-center align-items-center pl-half">
      <p class="typo-button14 typo-medium text-light-low text-upper">
        <svg class="mr-half" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="item.status == 'running'">
          <circle cx="4" cy="4" r="3.5" fill="#3C67FF" />
        </svg>
        {{ status }}
      </p>
    </div>
    <div class="col-3 col-md-2 column-center d-none d-md-flex align-items-center pl-half">
      <p class="typo-paragraph12 typo-regular text-light-low">
        <span v-if="(dayPassed > 0) && (dayPassed < item.duration)">{{ dayPassed }}/</span>
        <span>{{ $tc("banner.trial.day", item.duration, { count: item.duration }) }}</span>
      </p>
    </div>
    <div class="col-2 col-md-1 column-center align-items-center pl-half">
      <button class="btn d-flex align-items-center action reset-button" v-if="item.indicating" @click.stop>
        <svg class="spinning" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
          <path fill="currentColor" d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z" />
        </svg>
      </button>
      <template v-else>
        
        <!-- <button class="btn d-flex align-items-center action reset-button" v-if="item.status == 'on_hold'" @click.stop="start"> -->
        <button class="btn d-flex align-items-center action reset-button" 
          v-if="['on_hold', 'completed'].includes(item.status)" @click.stop="start"
          :class="{'disabled': isLimitStartCampaign}"
          :disabled="isLimitStartCampaign"
        >
          <i class="icon icon-start typo-icon-16" :class="{'disabled': isLimitStartCampaign}"></i>
        </button>
        <!-- <button class="btn d-flex align-items-center action reset-button" v-if="item.status == 'completed'" @click.stop="start">
          <i class="icon icon-restart typo-icon-16"></i>
        </button> -->
        <button class="btn d-flex align-items-center action reset-button" v-if="item.status == 'running'" @click.stop="stop">
          <i class="icon icon-stop typo-icon-16"></i>
        </button>
      </template>
    </div>
    <div class="col-2 col-md-1 column-center pl-half align-items-end">
      <CampaignDropdown :item="item" />
    </div>

    <Portal to="tooltips">
      <Tooltip :pointer="true" :width="'auto'" />
    </Portal>
  </div>

  <!-- Loading animation -->
  <div class="row campaign-item loading" v-else>
    <div class="col-1 column-center">
      <div class="skeleton skeleton-light id"></div>
    </div>
    <div class="col-5 column-center pl-half">
      <div class="skeleton skeleton-light name mb-1"></div>
      <div class="skeleton skeleton-light content"></div>
    </div>
    <div class="col-2 column-center align-items-center pl-half ml-auto">
      <div class="skeleton skeleton-light time"></div>
    </div>
    <div class="col-2 column-center align-items-end pl-half">
      <div class="skeleton skeleton-light status"></div>
    </div>
    <div class="col-1 column-center pl-half align-items-end">
      <div class="skeleton skeleton-light action"></div>
    </div>
  </div>
</template>

<script>
import { TimeMaker } from "@/plugins";
import { mapActions, mapGetters } from "vuex";
import { actions } from "@/store/analytic/types.js";
import CampaignDropdown from "./CampaignDropdown";
import { statusFormat } from "@/store/analytic/getters.js";
import errorHandle from "@/mixins/errorHandle.js";
import abTesting from "@/mixins/abTesting.js";

export default {
  name: "CampaignItem",
  components: {
    CampaignDropdown,
  },
  mixins: [
    errorHandle(),
    abTesting
  ],
  props: {
    item: Object
  },
  data() {
    return {
      interval: -1,
    }
  },
  computed: {
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    status() {
      const value = this.item.status;
      return statusFormat(value);
    },
    lastModified() {
      return new TimeMaker(this.item.updated_at).ago(this.language);
    },
    dayPassed() {
      if (!this.item || !this.item.started_at) {
        return 0;
      }
      let passed = Math.round(((new Date) - (new Date(this.item.started_at))) / 86400000);
      if (passed > this.item.duration) {
        return this.item.duration;
      }
      return passed;
    },
  },
  mounted() {
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.$forceCompute("dayPassed")
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    ...mapActions("analytic", {
      fetchDetail: actions.FETCH_DETAIL_ANALYTIC,
      startCampaign: actions.START_CAMPAIGN_ANALYTIC,
      stopCampaign: actions.STOP_CAMPAIGN_ANALYTIC,
    }),
    ...mapActions("page", {
      updateRunningCampaignId: "updateRunningCampaignId"
    }),
    select() {
      this.$emit("select", this.item);
    },
    close() {
      this.$emit("close", this.item);
    },
    start() {
      if (this.isLimitStartCampaign) return;
      let textSuccess = this.$t("status.success");
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.startCampaign({ id:this.item.id })
        .then(() => {
          this.fetchDetail({ id:this.item.id })
            .then(() => {
              this.updateRunningCampaignId({id:this.item.id});
              this.gSnackbarCommit({
                message: textSuccess,
                type: "success"
              });
            })
            .catch(err => {
              this.gSnackbarCommit({
                message: this.getErrorMessage(err),
                type: "error"
              });
            });
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        });
    },
    stop() {
      let textSuccess = this.$t("status.success");
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.stopCampaign({ id:this.item.id })
        .then(() => {
          this.fetchDetail({ id:this.item.id })
            .then(() => {
              this.updateRunningCampaignId({id: 0});
              this.gSnackbarCommit({
                message: textSuccess,
                type: "success"
              });
            })
            .catch(err => {
              this.gSnackbarCommit({
                message: this.getErrorMessage(err),
                type: "error"
              });
            });
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  padding: 0px 5px;
  min-height: 16px;
  min-width: 16px;
  font-weight: 500;
  font-size: 10px;
  line-height: 1;
  border-radius: 200rem;
  @include flex-center;
  background: $accent-red;
  color: $textDarkModeHigh;
  align-self: center;
}

.column-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.campaign-item {
  background: $light1;
  padding: 12px;
  border-radius: $radius;
  border: solid 1px $light3;
  @include trans-all;
  height: 80px;
  &:not(.loading) {
    cursor: pointer;
  }

  // &.unread {
  //   position: relative;
  //   &:before {
  //     content: "";
  //     height: 100%;
  //     width: 3px;
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     border-top-left-radius: $radius;
  //     border-bottom-left-radius: $radius;
  //     background: $accent-green;
  //   }

  //   .title {
  //     position: relative;
  //     max-width: calc(100% - 24px)
  //   }
  // }

  &:hover::v-deep {
    border-color: map-get($hybrid-shade-dark, "500");
  }
  .action:not(.disabled):hover, .action:not(:disabled):hover {
    background: $textDarkModeHigh;
    color: $textLightModeHigh;
  }
}

.action {
  $size: 40px;
  width: $size;
  height: $size;
  padding: 0;
  color: $textLightModeLow;
  @include flex-center;

  &:hover {
    color: $mono3 !important;
  }
}

.skeleton {
  min-height: 15px;
  border-radius: $radius;

  &.id {
    width: 50%;
    max-width: 38px;
  }

  &.name {
    width: 50%;
  }

  &.time {
    width: 50%;
    max-width: 70px;
  }

  &.status {
    height: 16px;
    width: 50%;
    max-width: 76px;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.spinning {
  animation-name: spin;
  animation-duration: 500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.icon-start {
  pointer-events: none;
  &.disabled {
    color: #666666 !important;
  }
}
</style>
